export default __webpack_public_path__ + "static/media/tablette-printer-merged.96a9fbd3.png";